import { Component, Input } from '@angular/core';
import { tabChange } from '../../../animations';

@Component({
  selector: 'psc-tab',
  templateUrl: './tab.component.html',
  animations: [tabChange],
})
export class TabComponent {
  @Input() tabTitle:string;
  @Input() active = false;
  @Input() tabClass: string = '';
  /**
   * Only necessary for when tabs are read from query parameters
   */
  @Input() name: string;
}
